import React, { useEffect, useState } from "react";
import axios from "axios";
import '../../styles/list-car.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ENDPOINT } from "../../Services/ENDPOINT";
import { navigate } from "../Customs/navigation";
import { Empty, Typography } from "antd";


const ListAllCars = ({ total_distance, data, totalDay, droptype }) => {
  const [cars, setCars] = useState([]);
  const [totalDistance, setTotalDistance] = useState("");
  const [apiTotalDistance, setApiTotalDistance] = useState(0);
  const [expandedCard, setExpandedCard] = useState(null);

  const baseImageUrl = ENDPOINT.base;

  console.log('data++++++++++++', data);
  console.log('data++++++++++++', total_distance);
  console.log("________", droptype);

  console.log('data++++++++++++', data?.rental_duration);


  useEffect(() => {
    if (!data) return;

    const distance = data?.total_distance;
    const type = data?.type;

    setTotalDistance(distance);

    if (distance && totalDay) {
      // console.log(" totalDay);", totalDay);

      // distance-based booking (outstation / package)
      fetchCarsWithDistance(distance, type, totalDay, droptype);
    } else if (distance) {
      // console.log("1");

      // distance-based but no totalDay
      fetchCarsWithDistance(distance, type, droptype);
    } else {
      // hourly rental
      fetchCars(type, data?.rental_duration);
    }
  }, [data, totalDay, droptype]);


  const fetchCarsWithDistance = async (distance, service_type, totalDay, droptype) => {
    try {
      console.log("const res = await axios.post(", distance, service_type);

      const totalDistance = droptype === "premium" ? distance * 2 : distance;

      console.log("!!!", totalDistance);


      const res = await axios.post(
        `${ENDPOINT.get_car_data_by_distance}`,
        {
          total_distance: totalDistance,
          type: service_type,
          o_ot_type: droptype, // premium or regular for outstation
          book_time: JSON.stringify(data?.pickup_time?.replace(/\+/g, " ")),
          // totalDay: totalDay
          totalDay: (droptype === "premium" || droptype === "regular") ? 1 : totalDay
        },
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      );

      console.log("res.data.data---------------------", res.data);

      if (res.data?.status) {
        setCars(res.data.data || []);
        console.log("res.data.data", res.data.data);
        setApiTotalDistance(res.data.total_distance || 0);
      }
    } catch (error) {
      console.error("Distance API error", error);
    }
  };

  const fetchCars = async (service_type, rental_hour) => {
    try {
      const res = await axios.post(
        `${ENDPOINT.get_car_data_by_distance}`,
        {
          type: service_type,
          rental_hour: rental_hour,
          book_time: JSON.stringify(data?.pickup_time?.replace(/\+/g, ' '))
        },
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      console.log("+++++", res.data);

      if (res.data?.status) {
        setCars(res.data.data || []);
      }
    } catch (error) {
      console.error("API error", error);
    }
  };

  const selectCar = (carId) => {
    navigate("/car-booking", {
      state: { 
          data: { ...data, carId, 
          totalDay: (droptype === "premium" || droptype === "regular") ? 1 : totalDay,
          droptype
       } }
      //(droptype === "premium" || droptype === "regular") ? 1 : totalDay
    });
  };

  const toggleExpand = (carId) => {
    setExpandedCard(expandedCard === carId ? null : carId);
  };

  const parseListItems = (text) => {
    if (!text) return [];
    return text.split('\n')
      .map(item => item.trim())
      .filter(item => item.length > 0)
      .map(item => item.replace(/^\*\s*/, ''));
  };

  console.log("total_distance in ListAllCars", total_distance);

  return (
    <div className="container" style={{ width: "100%", paddingTop: '2px', paddingBottom: '50px' }}>
      <div className="car-list-desktop">
        {cars.length === 0 ? (
          <div className="not-found">
            {/* <p className="text-center text-muted">No cars found.</p> */}


            <Empty
              image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
              styles={{ image: { height: 60 } }}
              description={
                <Typography.Text>
                  No cars found.
                </Typography.Text>
              }
            ></Empty>
          </div>
        ) : (
          [...cars]
            .sort((a, b) => {
              const priceA = a.calculation ? a.calculation.discounted_price : a.display_price;
              const priceB = b.calculation ? b.calculation.discounted_price : b.display_price;
              return priceA - priceB; // ascending order
            })
            .map((car) => {
              const calculation = car.calculation || null;
              const added_additional_price = car.added_additional_price || null;
              const image = car.upload_img ? baseImageUrl + car.upload_img : "assets/images/blog1.jpg";
              const isExpanded = expandedCard === car.id;

              const inclusions = parseListItems(car.inclusion);
              const exclusions = parseListItems(car.exclusion);
              const descriptions = parseListItems(car.description);

              return (
                <div className="car-card-horizontal" key={car.id}>
                  <div className="car-card-main">
                    {/* Left: Car Image */}
                    <div className="car-image-section">
                      <img src={image} alt={car.car_name} className="car-image-horizontal" />
                    </div>

                    {/* Middle: Car Details */}
                    <div className="car-details-section">
                      <div className="car-header">
                        <div>
                          <h3 className="car-name-horizontal">
                            {car.car_name}
                            {Number(car.rating) > 0 && (
                              <span className="car-rating">
                                <i className="fas fa-star"></i>{' '}
                                {Number(car.rating).toFixed(1).replace(/\.0$/, '')}
                              </span>
                            )}

                          </h3>
                          <p className="car-subtitle">{car.seater} Seats | {car?.car_spec}</p>
                        </div>
                        {calculation?.discount_percent > 0 && (
                          <div className="discount-badge-horizontal">
                            <i className="fas fa-circle"></i> {calculation.discount_percent}% OFF ₹{calculation.base_price}
                          </div>
                        )}
                      </div>

                      <div className="car-features">
                        <div className="feature-item">
                          <i className="fas fa-car"></i>
                          <span>{car?.fule_type} | {car?.car_type}</span>
                        </div>
                        <div className="feature-item">
                          <i className="fas fa-road"></i>
                          <span>

                            <span className="value">
                              {data?.type === "rental" && calculation?.min_travel_range_km}

                              {/* {data?.type !== "rental" && (
                                calculation?.rental_type === "outstation_round"
                                  ? calculation?.total_distance_per_rental_day
                                  : total_distance
                              )} */}
                              {data?.type !== "rental" && (
                                (calculation?.rental_type === "outstation_round"
                                  ? calculation?.total_distance_per_rental_day
                                  : total_distance) * (droptype === "premium" ? 2 : 1)
                              )}
                            </span>
                            kms included | Post limit: ₹{car.additional_travel_amount}/km
                          </span>
                        </div>
                      </div>

                      <div
                        className="inclusions-toggle"
                        onClick={() => toggleExpand(car.id)}
                      >
                        <span>Inclusions and Exclusions</span>
                        <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`}></i>
                      </div>
                    </div>

                    {/* Right: Price & Action */}
                    <div className="car-action-section">
                      <div className="price-section-horizontal">
                        <div className="price-main-horizontal">
                          ₹{calculation ? calculation.discounted_price : car.display_price}
                        </div>
                        {/* <div className="price-subtext">+ ₹{calculation ? Math.round(calculation.discounted_price * 0.05) : Math.round(car.display_price * 0.05)} Charges and Taxes</div> */}
                      </div>
                      <button
                        className="select-btn-horizontal"
                        onClick={() => selectCar(car.id)}
                      >
                        SELECT CAR
                      </button>
                    </div>
                  </div>

                  {/* Expandable Section */}
                  {isExpanded && (
                    <div className="car-expandable-section">
                      <h4 className="section-title">Inclusions and Exclusions</h4>

                      <div className="inclusions-exclusions-grid">
                        {/* Inclusions */}
                        <div className="inclusion-column">
                          {inclusions.length > 0 ? (
                            inclusions.map((item, index) => (
                              <>
                                <h5 className="column-title">Inclusions</h5>
                                <div className="inclusion-item" key={index}>
                                  <i className="fas fa-check-circle inclusion-icon"></i>
                                  <span>{item}</span>
                                </div>
                              </>
                            ))
                          ) : (
                            // <div className="empty-state">
                            //   <i className="fas fa-inbox"></i>
                            //   <span>No inclusions listed</span>
                            // </div>
                            <></>
                          )
                          }
                        </div>

                        {/* Exclusions */}
                        {exclusions.length > 0 && (
                          <div className="exclusion-column">
                            <h5 className="column-title">Exclusions</h5>
                            {exclusions.map((item, index) => (
                              <div className="exclusion-item" key={index}>
                                <i className="fas fa-times-circle exclusion-icon"></i>
                                <span>{item}</span>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Description */}
                        {descriptions.length > 0 && (
                          <div className="description-column">
                            <h5 className="column-title">Important Notes</h5>
                            {descriptions.map((item, index) => (
                              <div className="description-item" key={index}>
                                <i className="fas fa-info-circle description-icon"></i>
                                <span>{item}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })
        )}
      </div>
    </div>
  );
};

export default ListAllCars;